import { setupWorker } from "msw";
import { handlers as courseCardHandlers } from "./course/CourseCard/CourseCard.mockHandlers";
import { handlers as courseHomePageHandlers } from "./course/courseHomePage/CoursesHomePage.mockHandlers";

const handlers = [...courseCardHandlers, ...courseHomePageHandlers];

export const worker = setupWorker(...handlers);
